export const SITE = {
  name: "SkillLaunch",
  tagline: "Learn freelancing. Earn online. Start today.",
  supportPhone: process.env.REACT_APP_SUPPORT_PHONE || "0715347200",
  supportEmail: process.env.REACT_APP_SUPPORT_EMAIL || "skilllaunch@gmail.com",
  till: process.env.REACT_APP_TILL || "5405194",
  priceFullRaw: parseInt(process.env.REACT_APP_COURSE_PRICE_FULL || "3500"),
  priceReferredRaw: parseInt(
    process.env.REACT_APP_COURSE_PRICE_REFERRED || "3000",
  ),
  priceFull: `Ksh ${parseInt(process.env.REACT_APP_COURSE_PRICE_FULL || "3500").toLocaleString()}`,
  priceReferred: `Ksh ${parseInt(process.env.REACT_APP_COURSE_PRICE_REFERRED || "3000").toLocaleString()}`,
};

export const SUPPORT_MSG = `If you encounter any issues, call or WhatsApp ${SITE.supportPhone} or email ${SITE.supportEmail}`;

export const skillCategories = [
  {
    label: "Writing & Academic",
    items: [
      "Proofreading & Editing",
      "Academic Writing Assistance",
      "Copywriting",
      "Transcription",
      "Resume Writing",
    ],
  },
  {
    label: "Tutoring & Teaching",
    items: [
      "Online Tutoring",
      "ESL Teaching",
      "Test Prep",
      "Skills Coaching",
      "Course Creation",
    ],
  },
  {
    label: "AI & Automation",
    items: [
      "Prompt Engineering",
      "Data Labeling",
      "Workflow Automation",
      "Chatbot Building",
      "AI Content Editing",
    ],
  },
  {
    label: "Virtual Assistance",
    items: [
      "Email & Calendar",
      "Data Entry",
      "Research",
      "Customer Support",
      "Project Management",
    ],
  },
  {
    label: "Design & Creative",
    items: [
      "Graphic Design",
      "Video Editing",
      "Photography",
      "Voiceover",
      "Animation",
    ],
  },
  {
    label: "Digital Marketing",
    items: [
      "Social Media Management",
      "SEO",
      "Paid Ads",
      "Email Marketing",
      "Content Strategy",
    ],
  },
  {
    label: "Web Development",
    items: [
      "WordPress",
      "Webflow",
      "Shopify",
      "No-Code Apps",
      "Custom Development",
    ],
  },
  {
    label: "E-commerce & Reselling",
    items: [
      "Dropshipping",
      "WhatsApp Reselling",
      "Affiliate Marketing",
      "Etsy & Handmade",
      "Amazon FBA",
    ],
  },
];
